import React from "react";
import {
  Box,
  Button,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import { AddCircle, RemoveCircle } from "@mui/icons-material";

const DisplayList = ({ title, type, data, handleDialog, handleClick }) => {
  const displayItem = (item, idx) => {
    return type === "tagRange"
      ? `Range #${idx + 1}: ${item.start}${
          isNaN(item.end) ? "" : ", " + item.end
        } `
      : `${item}`;
  };

  return (
    <>
      <Box m="auto">
        <h2 className="sectionTitle center">{title}</h2>
      </Box>
      <Box
        display="flex"
        width="100%"
        justifyContent="center"
        alignItems="center"
      >
        <Box m={1} p={1}>
          <Button
            color="primary"
            startIcon={<AddCircle />}
            onClick={() => handleDialog(true)}
          >
            Add
          </Button>
        </Box>
        <Box>
          <List component="nav" dense>
            {data.map((item, idx) => {
              return (
                <ListItem
                  button
                  key={idx}
                  divider
                  onClick={(event) => handleClick(event, idx)}
                  dense
                >
                  <ListItemText>{displayItem(item, idx)}</ListItemText>
                  <ListItemIcon>
                    <RemoveCircle
                      style={{ color: "red", marginLeft: "20px" }}
                    />
                  </ListItemIcon>
                </ListItem>
              );
            })}
          </List>
        </Box>
      </Box>
    </>
  );
};

export default DisplayList;
